
const LOCAL_PROPERTIES_KEY = 'qubeyards-admin-properties';
const PROPERTY_OVERRIDES_KEY = 'qubeyards-property-overrides';
const readOverrides = () => { try { return JSON.parse(window.localStorage.getItem(PROPERTY_OVERRIDES_KEY) || '{}'); } catch { return {}; } };

export const readLocalProperties = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(LOCAL_PROPERTIES_KEY) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
};

export const getPropertyCatalog = () => readLocalProperties().filter((property) => !property.isDemo && !String(property.id).startsWith('demo-'));

export const addLocalProperty = (form, { source = 'admin', status = 'Published locally' } = {}) => {
  const properties = readLocalProperties();
  const slugBase = form.title.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'qy-property';
  const slug = properties.some((item) => item.slug === slugBase)
    ? `${slugBase}-${Date.now().toString(36)}`
    : slugBase;
  const imageUrls = (Array.isArray(form.imageUrls) ? form.imageUrls : String(form.imageUrls || '').split('\n'))
    .map((url) => String(url).trim()).filter(Boolean).slice(0, 6);
  const property = {
    ...form,
    id: `qy-${Date.now()}`,
    slug,
    title: form.title.trim(),
    category: form.propertyType || form.category || 'Apartment',
    purpose: form.purpose || 'SALE',
    price: form.purpose === 'RENT' ? null : Number(form.price) || null,
    monthlyRent: form.purpose === 'RENT' ? Number(form.monthlyRent) || null : null,
    bedrooms: Number(form.bedrooms) || 0,
    bathrooms: Number(form.bathrooms) || 0,
    builtUpArea: Number(form.builtUpArea) || 0,
    furnishing: form.furnishing || 'Unfurnished',
    amenities: Array.isArray(form.amenities) ? form.amenities : String(form.amenities || '').split(',').map((item) => item.trim()).filter(Boolean),
    images: imageUrls.length ? imageUrls : ['https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=82'],
    source,
    status,
    createdAt: new Date().toISOString(),
  };
  window.localStorage.setItem(LOCAL_PROPERTIES_KEY, JSON.stringify([property, ...properties]));
  return property;
};

export const updateLocalProperty = (id, form) => {
  const local = readLocalProperties();
  const existing = local.find((property) => property.id === id);
  const imageUrls = (Array.isArray(form.imageUrls) ? form.imageUrls : String(form.imageUrls || '').split('\n')).map((url) => String(url).trim()).filter(Boolean).slice(0, 6);
  const updated = { ...existing, ...form, id, title: form.title.trim(), description: form.description.trim(), category: form.propertyType || form.category || existing?.category || 'Apartment', purpose: form.purpose || 'SALE', price: form.purpose === 'RENT' ? null : Number(form.price) || null, monthlyRent: form.purpose === 'RENT' ? Number(form.monthlyRent) || null : null, bedrooms: Number(form.bedrooms) || 0, bathrooms: Number(form.bathrooms) || 0, builtUpArea: Number(form.builtUpArea) || 0, images: imageUrls.length ? imageUrls : existing?.images || [], amenities: Array.isArray(form.amenities) ? form.amenities : String(form.amenities || '').split(',').map((item) => item.trim()).filter(Boolean), updatedAt: new Date().toISOString() };
  if (existing) window.localStorage.setItem(LOCAL_PROPERTIES_KEY, JSON.stringify(local.map((property) => property.id === id ? updated : property)));
  else window.localStorage.setItem(PROPERTY_OVERRIDES_KEY, JSON.stringify({ ...readOverrides(), [id]: updated }));
  return updated;
};

export const deleteLocalProperty = (id) => {
  window.localStorage.setItem(LOCAL_PROPERTIES_KEY, JSON.stringify(readLocalProperties().filter((property) => property.id !== id)));
};
